import useTypes from "./types";

const useStrings = () => {
  return {
    useTypes
  };
};

export default useStrings;
